import { chainConfig, ethereumFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { stable as viemStableBase } from 'viem/chains'

import type { AppChain } from './chain.types'

export const stable = viemDefineChain({
  ...viemStableBase,
  ...chainConfig,
  contracts: {
    ...viemStableBase.contracts,
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 2423647
    }
  }
}).extend({
  viemDlc: ethereumFacts,
  custom: {
    name: 'Stable',
    shortName: 'Stable',
    safeShortName: 'stable',
    morphoChainSlug: 'stable',
    defiLlamaSlug: 'stable',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://stablescan.xyz/', name: 'Stablescan' },
    gasToken: { address: '0x779Ded0c9e1022225f8E0630b35a9b54bE713736', decimals: 6 },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x41e846FC8108b8527C1D4EDB4c9564E56442940f',
          startBlock: 1504506n
        },
        MorphoBlue: { address: '0xa40103088A899514E3fe474cD3cc5bf811b1102e', startBlock: 1504506n },
        MetaMorphoV11Factory: {
          address: '0xb4ae5673c48621189E2bEfBA96F31912032DD1AE',
          startBlock: 1504774n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x7fc35488803D49D00a94b206A223f7661898BE3a',
          startBlock: 1506182n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0x2A5F218FE4Dac3b1f4E096e8ae83074bB1713833',
          startBlock: 1506182n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x9282DBa3d1788f4f02B5DdFc4fc5985e70197620',
          startBlock: 5110812n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0x4EF83ACD552598a1196c1aBDD0bA2EdE6f2237B4',
          startBlock: 1506182n
        },
        RegistryList: {
          address: '0xCe93fcB2849EB886F1e81d45D2747dF803f843C3',
          startBlock: 1506877n
        },
        BluePublicAllocator: {
          address: '0x5C884d4B1510EAd302EC50A2AB4DE9c0b9E407ce',
          startBlock: 35817019n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
